module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3a.5c33bbc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3a.svg
// module id = 548
// module chunks = 0